import { render } from "./CarPage.vue?vue&type=template&id=4789e583&ts=true"
import script from "./CarPage.vue?vue&type=script&lang=ts"
export * from "./CarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__